export default "__VITE_ASSET__BoQ9C5kl__"